import * as t from 'io-ts';

import {makeEnumRuntimeType} from './apiTypes';
import {RConversationSortProperty} from './conversationCommonTypes';

/*
 * Runtime type.
 */

export const searchSortOptionKey = 'search';

export enum CellsSortDirectionsEnum {
  ASCENDING = 'ASCENDING',
  DESCENDING = 'DESCENDING',
}
export const RCellsSortDirection = makeEnumRuntimeType(CellsSortDirectionsEnum);

export const RSortOption = t.readonly(
  t.type({
    sortDirection: RCellsSortDirection,
    sortProperty: t.union([t.undefined, RConversationSortProperty]),
  }),
);

/*
 * Type.
 */

export interface SortOptionModel extends t.TypeOf<typeof RSortOption> {}
